import axios from "axios";

export const consultRuc = async (ruc, type = "ruc") => {
  let res = await axios.post(`https://api.migo.pe/api/v1/${type}`, {
    token: "sV9ao0onev11xHrWkJSKdLH24QDvYAI6OPpTYVzTLzobxFIBzi5RY8SY6EjM",
    [type]: ruc,
  });
  return res.data;
};
